@for (item of rateArr; track item) {
  <mat-icon> star </mat-icon>
}
